import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { connect, useDispatch } from 'react-redux';
import { imageBaseUrls } from '../../constant/ApiUrls';
import { useLocation } from 'react-router-dom';
import AddSettings from '../settings/components/AddSetings';
import { settingsLisitingRequest } from '../settings/redux/settingsDispatcher';
import placeholderImage from "../../components/assets/image/placeholder.png";


function SettingsListingTable({ settingsListing }) {

  console.log("settings listing-----", settingsListing);
  const paginationModel = { page: 0, pageSize: 10 };

  const dispatch = useDispatch();
  const location = useLocation();

  var imagesField = ['home', 'marketplace', 'farming', 'property','finance-form']

  var linkFields = ['Instagram', 'facebook', 'twitter', 'youtube', 'linkedIn',]


  var contactUsFields = ['Instagram', 'facebook', 'twitter', 'youtube', 'linkedIn', 'address', 'email', 'phone']



  const settingsListingHeading = [

    {
      field: "id", headerName: "NO", width: 40,
      renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
    },

    {
      field: "col", headerName: "Setting Title", width: 270,
      renderCell: (params) => {
        var title = <div><strong>{params.value.charAt(0).toUpperCase() + params.value.slice(1)}</strong></div>;
        if (params.row.col === "home") {
          title = <div><strong>Home Page - </strong>Mottor Mall Banner</div>
        }
        else if (params.row.col === "marketplace") {
          title = <div><strong>Home Page - </strong>Marketplace Banner</div>
        }


        else if (params.row.col === "farming") {
          title = <div><strong>Home Page - </strong>Farming Banner</div>
        }
        else if (params.row.col === "property") {
          title = <div><strong>Home Page - </strong>Property</div>
        }
        else if (contactUsFields.includes(params.row.col)) {
          title = <div><strong>Contact Us - </strong>{params.value.charAt(0).toUpperCase() + params.value.slice(1)}</div>
        }
        return <div>{title}</div>
      }
      // renderCell: (params) => params.value, 
    },

    {
      field: "value", headerName: "Value", width: 400,
      sortable: false,
      renderCell: (params) => {

        if (imagesField.includes(params.row.col)) {
          console.log("params.value:::", params.value);
          return (
            <img
              src={params.value ? `${imageBaseUrls(params.value)}` : placeholderImage}
              alt="Value"
              style={{ width: 200, height: 80, borderRadius: "10px" }}
            />
          );

        }
        else if (linkFields.includes(params.row.col)) {
          return (
            <a
              href={params.value}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#007bff",
                textDecoration: "underline",
              }}
            >
              {params.value}
            </a>
          );
        }
        else {

          return (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <h6>{params.value}</h6>
            </div>
          );
        }
      },
    },



    {
      field: "action",
      headerName: "Action",
      width: 300,
      sortable: false,
      renderCell: (params, row) => {
        console.log("veiw is called", params, row);


        return (
          <div style={{
            display: "flex", flexDirection: "row", gap: "4px", alignItems: "center",
            height: "100%"
          }}>
            <AddSettings
              buttonLabel="Edit"
              editMode={true}
              settingsData={params.row}
              imagesField={imagesField}
              linkFields={linkFields}
            />





          </div>

        );
      },
    },


  ];





  React.useEffect(() => {


    dispatch(settingsLisitingRequest());
  }, [dispatch, location.pathname]);

  return (

    <Paper sx={{ height: "95%", width: '100%' }}>





      {/* <div style={{ padding: "10px", justifyItems: "end" }}>
        <AddSettings
          imagesField={imagesField}
          linkFields={linkFields}


        />
      </div> */}






      <DataGrid
        rows={settingsListing.settingsListing || []}
        columns={settingsListingHeading || []}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[10, 25]}
        rowHeight={80}
        loading={settingsListing.loading}
        checkboxSelection={false}
        sx={{ border: 0 }}


      />
    </Paper>
  );
}




//Getting the state from the store
const mapStateToProps = (state) => {
  console.log(
    "PERMISSSION:::::::::"
    , state.settingsReducer);
  return {
    settingsListing: state.settingsReducer, // Add optional chaining
  };
};



//passing the settings Data  in fetchSettings function and also dispatch method
const mapDispatchToProps = (dispatch) => {
  return {
    settingsLisitingRequest: () => dispatch({ "type": "GET_SETTINGS_REQUEST" }), // Corrected function name
  };
};




//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(SettingsListingTable);
